<template lang="pug">
  v-popover(
    :placement='actionsPlacement'
    :delay='{show: 100, hide: 600}'
    trigger='hover click'
    popoverClass='krea-actions-popover'
    :container='false'
  )
    .column.m-bottom-2
      .row.middle.m-bottom-05
        simple-svg.dark-gray-icon.m-right-1(:filepath='ageIcon' width='18px' height='18px')
        label.text-small.dark-gray {{ $t("krea.educationalContent.levelLabel") }}
      .container.row.middle.m-left-3(v-if='edition')
        .row.middle
          krea-k-select.select(
            name='academicGrade' noActions small
            :placeholder='$t("krea.educationalContent.levelPlaceholder")'
            :emptyOption='$t("krea.educationalContent.levelEmptyOption")'
            @selectOption='editLevel'
            :value='level'
            :options='levelsOptions'
          )
        .row.middle
          p.text-normal.m-top-05(v-if='!edition && content.academicGradeId') {{ gradeLabel }}
          krea-k-select.select(
            name='academicGrade' noActions small
            :disabled='!level'
            :placeholder='$t("krea.educationalContent.gradePlaceholder")'
            :emptyOption='$t("krea.educationalContent.gradeEmptyOption")'
            @selectOption='editGrade'
            :value='content.academicGradeId'
            :options='coursesOptions'
          )
      p.text-normal.m-left-3(v-else) {{ valueLabel }}
    template(slot="popover")
      actions(
        @edit='toggleEdition'
        :edit='edit'
        :comments='comments'
        :pdf='pdf'
        :link='link'
        :info='info'
        :placement='actionsPlacement.split("-")[1]'
      )
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { i18n } from '../../../main'
import userRole from '../../../mixins/userRole'
import kreaActions from '@/mixins/kreaActions'
import Actions from '../Inputs/Actions/Actions'
import KreaKSelect from '../Inputs/KreaKSelect'
import ageIcon from '@/assets/ic_ageyear.svg'

export default {
  mixins: [userRole, kreaActions],
  components: { KreaKSelect, Actions },
  data() {
    return {
      edition: true,
      ageIcon,
      level: null
    }
  },
  mounted() {
    if (this.content.academicGrade) {
      this.level = this.content.academicGrade.educationalLevelId
    }
  },
  computed: {
    ...mapState({
      academicCourses: state => state.dashboard.academicCourses,
      content: state => state.kreaEducationalContent.content
    }),
    valueLabel() {
      return this.levelLabel + ' ' + this.gradeLabel
    },
    levelLabel() {
      const grade = this.academicCourses.find(({ academicGrade }) => academicGrade.id === this.content.academicGradeId)
      return i18n.t(`educationalLevels.${grade.academicGrade.educationalLevelId}`)
    },
    gradeLabel() {
      const grade = this.academicCourses.find(({ academicGrade }) => academicGrade.id === this.content.academicGradeId)
      return i18n.t(`academicGrades.${grade.academicGrade.educationalType}.${grade.academicGrade.translationId}`)
    },
    levelsOptions() {
      return this.userEducationalLevels.map(lvl => ({
        value: lvl,
        label: i18n.t(`educationalLevels.${lvl}`)
      }))
    },
    coursesOptions() {
      return this.academicCourses
        .filter(({ academicGrade }) => academicGrade.educationalLevelId === this.level)
        .map(({ academicGrade, id }) => ({
          value: academicGrade.id,
          label: i18n.t(`academicGrades.${academicGrade.educationalType}.${academicGrade.translationId}`)
        }))
    }
  },
  methods: {
    ...mapActions([
      'editKreaContentField'
    ]),
    toggleEdition() {
      if (!this.content.academicGradeId) return
      this.edition = !this.edition
    },
    editLevel(name, value) {
      this.level = value
      this.editKreaContentField({ field: 'academicGradeId', value: null })
    },
    editGrade(name, value) {
      this.editKreaContentField({ field: 'academicGradeId', value })
    }
  }
}
</script>

<style lang="scss" scoped>

.container{
  flex-wrap: wrap;
  gap: 10px;
}

.select{
  width: 180px;
}
</style>
